"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _store = require("../store");
var _propTypes = _interopRequireDefault(require("prop-types"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var FormReact = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(FormReact, _React$Component);
  var _super = _createSuper(FormReact);
  function FormReact() {
    (0, _classCallCheck2.default)(this, FormReact);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(FormReact, [{
    key: "renderATypes",
    value: function renderATypes() {
      if (!this.props.form.formData.aType) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "options"
        }, /*#__PURE__*/_react.default.createElement("div", {
          onClick: this.updateFieldInfo.bind(this),
          id: "aType1",
          tabIndex: "0",
          className: "type"
        }, "Checking"), /*#__PURE__*/_react.default.createElement("div", {
          onClick: this.updateFieldInfo.bind(this),
          id: "aType2",
          tabIndex: "0",
          className: "type"
        }, "Savings"));
      } else if (this.props.form.formData.aType === 'Checking') {
        if (this.props.form.showConfirmationPage) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "options read-only"
          }, /*#__PURE__*/_react.default.createElement("div", null, "Checking"));
        }
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "options"
        }, /*#__PURE__*/_react.default.createElement("span", {
          onClick: this.updateFieldInfo.bind(this),
          id: "aType1",
          tabIndex: "0",
          className: "type selected"
        }, "Checking"), /*#__PURE__*/_react.default.createElement("div", {
          onClick: this.updateFieldInfo.bind(this),
          id: "aType2",
          tabIndex: "0",
          className: "type"
        }, "Savings"));
      } else if (this.props.form.formData.aType === 'Savings') {
        if (this.props.form.showConfirmationPage) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "options read-only"
          }, /*#__PURE__*/_react.default.createElement("div", null, "Savings"));
        }
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "options"
        }, /*#__PURE__*/_react.default.createElement("div", {
          onClick: this.updateFieldInfo.bind(this),
          id: "aType1",
          tabIndex: "0",
          className: "type"
        }, "Checking"), /*#__PURE__*/_react.default.createElement("span", {
          onClick: this.updateFieldInfo.bind(this),
          id: "aType2",
          tabIndex: "0",
          className: "type selected"
        }, "Savings"));
      }
    }
  }, {
    key: "showToolTip",
    value: function showToolTip(event) {
      event.target.nextSibling.classList.add('in');
    }
  }, {
    key: "hideToolTip",
    value: function hideToolTip(event) {
      event.target.nextSibling.classList.remove('in');
      if (event.currentTarget.value !== '') {
        this.props.addValidations(event.currentTarget.name, event.currentTarget.value);
      }
    }
  }, {
    key: "validate",
    value: function validate(event) {
      this.props.addValidations(event.currentTarget.name, event.currentTarget.value);
    }
  }, {
    key: "updateFieldInfo",
    value: function updateFieldInfo(event) {
      event.persist();
      if (event.currentTarget.type === 'checkbox') {
        if (event.currentTarget.checked) {
          this.props.updateFormField(event.currentTarget.name, 'checked');
        } else {
          this.props.updateFormField(event.currentTarget.name, '');
        }
      } else if (event.currentTarget.type === 'text' || event.currentTarget.type === 'textarea' || event.currentTarget.type === 'select-one') {
        if (event.currentTarget.name === 'rNumber' && event.currentTarget.value.length > 6) {
          this.props.getBankName(event.currentTarget.name, event.currentTarget.value);
        } else {
          this.props.updateFormField(event.currentTarget.name, event.currentTarget.value);
        }
      } else {
        if (event.currentTarget.id.indexOf('aType') > -1) {
          this.props.updateFormField('aType', event.currentTarget.innerHTML);
        }
      }
    }
  }, {
    key: "renderField",
    value: function renderField(field, placeholder, errorMessage, className, tooltipMessage) {
      var _this = this;
      var renderToolTip = function renderToolTip(tooltipMessage) {
        if (tooltipMessage) {
          var returnInput = function returnInput(field) {
            if (field === 'caNumber') {
              return /*#__PURE__*/_react.default.createElement("input", {
                onPaste: function onPaste(e) {
                  return e.preventDefault();
                },
                onFocus: _this.showToolTip,
                onBlur: _this.hideToolTip.bind(_this),
                onMouseEnter: _this.showToolTip,
                onMouseLeave: _this.hideToolTip.bind(_this),
                id: field,
                type: "text",
                "data-popover-target": field + '-popover',
                onChange: _this.updateFieldInfo.bind(_this),
                className: className + ' form-control',
                name: field,
                placeholder: placeholder,
                value: _this.props.form.formData[field]
              });
            }
            return /*#__PURE__*/_react.default.createElement("input", {
              onFocus: _this.showToolTip,
              onBlur: _this.hideToolTip.bind(_this),
              onMouseEnter: _this.showToolTip,
              onMouseLeave: _this.hideToolTip.bind(_this),
              id: field,
              type: "text",
              "data-popover-target": field + '-popover',
              onChange: _this.updateFieldInfo.bind(_this),
              className: className + ' form-control',
              name: field,
              placeholder: placeholder,
              value: _this.props.form.formData[field]
            });
          };
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "col-xs-12 row"
          }, returnInput(field), /*#__PURE__*/_react.default.createElement("div", {
            className: "popover right visible-sm",
            role: "tooltip",
            "data-popover-id": field + '-popover'
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "popover-content"
          }, tooltipMessage)), /*#__PURE__*/_react.default.createElement("div", {
            className: "popover bottom hidden-sm",
            role: "tooltip",
            "data-popover-id": field + '-popover'
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "popover-content"
          }, tooltipMessage)));
        }
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "col-xs-12 row"
        }, /*#__PURE__*/_react.default.createElement("input", {
          onTouchMove: _this.validate.bind(_this),
          onBlur: _this.validate.bind(_this),
          onMouseLeave: _this.validate.bind(_this),
          id: field,
          type: "text",
          onChange: _this.updateFieldInfo.bind(_this),
          className: className + ' form-control',
          name: field,
          placeholder: placeholder,
          value: _this.props.form.formData[field]
        }));
      };
      if (this.props.form.errorFields.indexOf(field) === -1) {
        if (this.props.form.showConfirmationPage) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "form-group read-only"
          }, /*#__PURE__*/_react.default.createElement("div", null, this.props.form.formData[field]));
        }
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "form-group"
        }, renderToolTip(tooltipMessage));
      }
      if (tooltipMessage) {
        var returnInput = function returnInput(field) {
          if (field === 'caNumber') {
            return /*#__PURE__*/_react.default.createElement("input", {
              onPaste: function onPaste(e) {
                return e.preventDefault();
              },
              onFocus: _this.showToolTip,
              onBlur: _this.hideToolTip.bind(_this),
              onMouseEnter: _this.showToolTip,
              onMouseLeave: _this.hideToolTip.bind(_this),
              id: field,
              type: "text",
              "data-popover-target": field + '-popover',
              value: _this.props.form.formData[field],
              onChange: _this.updateFieldInfo.bind(_this),
              name: field,
              placeholder: placeholder,
              className: "number form-control has-error",
              "data-aid": field
            });
          }
          return /*#__PURE__*/_react.default.createElement("input", {
            onFocus: _this.showToolTip,
            onBlur: _this.hideToolTip.bind(_this),
            onMouseEnter: _this.showToolTip,
            onMouseLeave: _this.hideToolTip.bind(_this),
            id: field,
            type: "text",
            "data-popover-target": field + '-popover',
            value: _this.props.form.formData[field],
            onChange: _this.updateFieldInfo.bind(_this),
            name: field,
            placeholder: placeholder,
            className: "number form-control has-error",
            "data-aid": field
          });
        };
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col-xs-12 row has-error"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "has-error"
        }, returnInput(field), /*#__PURE__*/_react.default.createElement("div", {
          className: "popover right visible-sm",
          role: "tooltip",
          "data-popover-id": field + '-popover'
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "popover-content"
        }, tooltipMessage)), /*#__PURE__*/_react.default.createElement("div", {
          className: "popover bottom hidden-sm",
          role: "tooltip",
          "data-popover-id": field + '-popover'
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "popover-content"
        }, tooltipMessage)), /*#__PURE__*/_react.default.createElement("div", {
          className: "error-message",
          "data-error-for": field
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "icon icon-form-error error-image"
        }), /*#__PURE__*/_react.default.createElement("span", {
          className: "error-text",
          "data-aid": "error-text"
        }, errorMessage)))));
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 row has-error"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "has-error"
      }, /*#__PURE__*/_react.default.createElement("input", {
        onFocus: this.showToolTip,
        onBlur: this.hideToolTip.bind(this),
        onMouseEnter: this.showToolTip,
        onMouseLeave: this.hideToolTip.bind(this),
        id: field,
        type: "text",
        "data-popover-target": field + '-popover',
        value: this.props.form.formData[field],
        onChange: this.updateFieldInfo.bind(this),
        name: field,
        placeholder: placeholder,
        className: "number form-control has-error",
        "data-aid": field
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "error-message",
        "data-error-for": field
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "icon icon-form-error error-image"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "error-text",
        "data-aid": "error-text"
      }, errorMessage)))));
    }
  }, {
    key: "openOrClose",
    value: function openOrClose() {
      this.props.openOrCloseModal(!this.props.modal.isOpen);
    }
  }, {
    key: "returnNBTDisclosure",
    value: function returnNBTDisclosure() {
      if (this.props.form.showConfirmationPage) {
        var isAgreementChecked = this.props.form.formData.agreement ? this.props.form.formData.agreement : '';
        var errorState = '';
        if (isAgreementChecked === '') {
          errorState = 'error-state';
        }
        return /*#__PURE__*/_react.default.createElement("div", {
          className: errorState
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "agreement-checkbox"
        }, /*#__PURE__*/_react.default.createElement("input", {
          onChange: this.updateFieldInfo.bind(this),
          name: "agreement",
          type: "checkbox",
          checked: isAgreementChecked
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "agreement"
        }, " I have read and agree to the ", /*#__PURE__*/_react.default.createElement("a", {
          onClick: this.openOrClose.bind(this),
          tabIndex: "0",
          className: "agreement-link"
        }, " NBT Auto Payments Authorization Agreement.")));
      }
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "agreement"
      }, "Not an account holder ? ", /*#__PURE__*/_react.default.createElement("a", {
        href: "https://www.nbtbank.com/content/recurringachpayments/",
        target: "_blank",
        rel: "noopener noreferrer",
        tabIndex: "0",
        className: "agreement-link"
      }, " Visit NBT Bank\u2019s webform "), " to setup automated payments. You will need your NBT Loan Account number, located in your NBT welcome letter."));
    }
  }, {
    key: "returnaTypeHeading",
    value: function returnaTypeHeading() {
      if (this.props.form.showConfirmationPage) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "heading"
        }, "Account Type");
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "heading"
      }, "Account Type (Select one)");
    }
  }, {
    key: "render",
    value: function render() {
      var siteInfo = this.props.siteInfo;
      var containerClass = siteInfo && (siteInfo.realm === 'LCYTS' || siteInfo.realm === 'LCK12') ? 'ach-form-container yts-parent' : siteInfo && siteInfo.realm === 'LCPS' ? 'ach-form-container lcps-parent' : 'ach-form-container';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: containerClass
      }, /*#__PURE__*/_react.default.createElement("form", {
        className: "form col-md-12",
        id: "ach-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "banking-info"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", null, "Banking Information"), /*#__PURE__*/_react.default.createElement("div", {
        className: "account-type"
      }, this.returnaTypeHeading.call(this), this.renderATypes.call(this)), /*#__PURE__*/_react.default.createElement("div", {
        className: "account-info"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "routing-number"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "heading"
      }, "Routing Number"), this.renderField.call(this, 'rNumber', 'Enter routing number', 'Enter a valid routing number.', 'col-xs-12', 'This is the first set of numbers (9 digits) printed on the bottom of your check, and begins with 0, 1, 2 or 3.')), /*#__PURE__*/_react.default.createElement("div", {
        className: "institution-name"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "heading"
      }), /*#__PURE__*/_react.default.createElement("div", null, this.props.form.formData.FIName)), /*#__PURE__*/_react.default.createElement("div", {
        className: "account-number"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "heading"
      }, "Account Number"), this.renderField.call(this, 'aNumber', 'Enter account number', 'Enter a valid account number.', 'col-xs-12', 'This is the second set of numbers printed on the bottom of your check.')), /*#__PURE__*/_react.default.createElement("div", {
        className: "account-number"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "heading"
      }, "Confirm Account Number"), this.renderField.call(this, 'caNumber', 'Confirm account number', 'Account numbers do not match. Please review.', 'col-xs-12', 'This is the second set of numbers printed on the bottom of your check.'))), /*#__PURE__*/_react.default.createElement("h3", null, "Account Holder Information"), /*#__PURE__*/_react.default.createElement("div", {
        className: "firstandlast-name"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "first-name"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "heading"
      }, "First Name"), /*#__PURE__*/_react.default.createElement("div", {
        className: "content"
      }, this.props.form.formData.fname)), /*#__PURE__*/_react.default.createElement("div", {
        className: "last-name"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "heading"
      }, "Last Name"), /*#__PURE__*/_react.default.createElement("div", {
        className: "content"
      }, this.props.form.formData.lname)))), !this.props.form.showConfirmationPage && /*#__PURE__*/_react.default.createElement("div", {
        className: "check-image"
      })), this.returnNBTDisclosure()));
    }
  }]);
  return FormReact;
}(_react.default.Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    modal: state.modal,
    siteInfo: state.siteInfo,
    form: state.form
  };
};
FormReact.propTypes = {
  siteInfo: _propTypes.default.object,
  form: _propTypes.default.shape({
    showConfirmationPage: _propTypes.default.bool,
    formData: _propTypes.default.object,
    errorFields: _propTypes.default.array,
    currentFocus: _propTypes.default.string
  }),
  addValidations: _propTypes.default.func,
  updateFormField: _propTypes.default.func,
  getBankName: _propTypes.default.func,
  modal: _propTypes.default.shape({
    isOpen: _propTypes.default.bool.isRequired
  }),
  openOrCloseModal: _propTypes.default.func
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var Form = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FormReact);
var _default = Form;
exports.default = _default;
